"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionType = void 0;
var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["FREE"] = "free";
    SubscriptionType["TRIAL"] = "trial";
    SubscriptionType["PREMIUM"] = "premium";
    SubscriptionType["PROMOTIONAL"] = "promotional";
})(SubscriptionType || (exports.SubscriptionType = SubscriptionType = {}));
